import * as types from '~/store/getContent/getContentType';



export const getContent = type => {
  return {
    type: types.GET_CONTENT,
    payloads: type,
  };
};

